import { styled, Container, Typography } from "@material-ui/core";

const styleScheme = {
  "half-leaves": "#5d5fef",
  "full-leaves": "#f0da67",
  "late-arrivals": "#ff6584",
  punctual: "#2bd48d",
};

const StyledContainer = (data) =>
  styled(Container)(() => ({
    backgroundColor: "white",
    height: "150px",
    width: "500px",
    borderRadius: "20px",
    paddingTop: "30px",
    paddingLeft: "20px",
    borderLeft: "15px solid",
    borderColor: styleScheme[data.label],
    boxShadow:
      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
    position: "relative",
  }));

const StyledBody = styled(Typography)(() => ({
  color: "#c6c7c9",
  fontWeight: "bold",
  fontFamily: "Poppins",
  fontSize: "20px",
}));

const StyledDate = styled(Typography)(() => ({
  color: "#5d5fef",
  fontWeight: "bold",
  fontFamily: "Poppins",
  fontSize: "20px",
}));

const StyledAnalytics = styled(Typography)(() => ({
  color: "#000",
  fontWeight: "bold",
  fontSize: "17px",
  marginTop: "20px",
  fontFamily: "Poppins",
}));

const StyledField = styled(Typography)(() => ({
  fontSize: "12px",
  color: "#868d95",
  fontFamily: "Poppins",
}));

const imageStyles = {
  position: "relative",
  height: "60px",
  maxWidth: "100%",
  marginTop: "0px",
};

const imageBgStyles = {
  position: "absolute",
  top: 0,
  right: 0,
  height: "150px",
  borderRadius: "20px",
  opacity: 0.37,
};

export {
  StyledContainer,
  StyledBody,
  StyledAnalytics,
  StyledDate,
  StyledField,
  imageStyles,
  imageBgStyles,
};
